import firebase from 'firebase/compat/app';
import "firebase/compat/auth";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFirestore } from 'firebase/firestore/lite';
import ReactObserver from 'react-event-observer';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from "firebase/analytics";

// Firebase config - DEV
export const firebaseConfig = {
  apiKey: "AIzaSyAhNutQxgX4WBuYUVm1aAUHT17t6AP1m0w",
  authDomain: "icrops-bms-dev.firebaseapp.com",
  projectId: "icrops-bms-dev",
  storageBucket: "icrops-bms-dev.appspot.com",
  messagingSenderId: "650029559598",
  appId: "1:650029559598:web:329df0bc0cce4fbdc894bf",
  measurementId: "G-X3KFTWXWMK"
};

export const app = firebase.initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, process.env.REACT_APP_FIREBASE_REGION);
export const analytics = getAnalytics(app);

export const firebaseObserver = ReactObserver();
firebase.auth().onAuthStateChanged(function(user) {
  if (user) {
    user.getIdTokenResult().then(function(data) {
      firebaseObserver.publish("userAuthContext",
        {
          displayName: user.displayName,
          roles: data.claims?.roles,
        }
      );
    });
  } else {
    firebaseObserver.publish("userAuthContext",
      null
    );
  }
});
